import { logoutRequest } from '@/lib/auth/common/client';
import { clearInvalidSession } from './clear-session';

/**
 * Imperative logout for non-React call sites; components should prefer useLogout()
 * (lib/auth/common/useSession.ts), which also clears React Query caches. Never throws —
 * the caller ends up logged out client-side either way.
 *
 * Server logout runs before clearing client state: only the server response can clear
 * the HttpOnly cookies, and clearing localStorage first would leave a window where the
 * still-valid cookie could resurrect the user. `finally` ensures local teardown still
 * runs even if the API is unreachable.
 */
export default async function logout() {
  try {
    return await logoutRequest();
  } catch {
    // Network failure or already-invalid session — nothing more the server can do.
    return null;
  } finally {
    clearInvalidSession();
  }
}
